import { RequirementConfig } from "../../core/_models/requirement-config.model";

export enum TemperatureTrackingDeviceAnswer {
  NO = "default_no",
  YES = "emd_yes",
}

export const TemperatureTrackingDeviceConfig: RequirementConfig = {
  "summaryLabel": "Temperature tracking device :",
  "question": "ANY TEMPERATURE TRACKING DEVICE ?",
  "options": [
    {
      "label": "No",
      "value": TemperatureTrackingDeviceAnswer.NO,
    },
    {
      "label": "Yes",
      "value": TemperatureTrackingDeviceAnswer.YES,
    },
  ],
};
